import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../store'
import { AxiosError, AxiosResponse } from 'axios'
import {
  deleteSharedWorkloadSuccess,
  RequestFailureMessage,
} from '../../../common/utils/messagesContants'
import { startLoading, stopLoading, LoadingTypes } from '@labrav/common'
import { camelize } from 'casing'
import {
  deleteSharedWorkload,
  fetchSharedWorkloadList,
} from '../../api/cloudfaas/wafr'
import { WorkloadShareListState, WorkloadShareSummary } from './reducer'

export const GET_WORKLOAD_SHARE_SUMMARY_SUCCESS =
  'GET_WORKLOAD_SHARE_SUMMARY_SUCCESS'

export const getSharedAccList =
  (partnerId: string, workloadId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.SHARE_LIST))
    try {
      const response = await fetchSharedWorkloadList(partnerId, workloadId)
      if (response?.data) {
        const sharedAccListResponse = camelize(
          response?.data
        ) as WorkloadShareListState
        const workloadShareSummaries =
          sharedAccListResponse?.workloadShareSummaries
        dispatch(
          setSharedAccList(sharedAccListResponse as WorkloadShareListState)
        )
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.SHARE_LIST))
    }
  }

export const deleteSharedWorkloadById =
  (partnerId: string, workloadId: string, shareId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.DELETE_SHARED_WORKLOAD))
    try {
      await deleteSharedWorkload(partnerId, workloadId, shareId)
      dispatch(
        updateAppAlert({
          message: deleteSharedWorkloadSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.DELETE_SHARED_WORKLOAD))
    }
  }

export const setSharedAccList = (payload: WorkloadShareListState) => ({
  type: GET_WORKLOAD_SHARE_SUMMARY_SUCCESS,
  payload,
})
